import { ADD_STOCK, ADD_STOCK_RETURN, CUSTOMERS_DROPDOWN, DELETE_INVENTORY, EDIT_INVENTORY, INVENTORY_LIST, NEW_STOCKS_LIST, NEW_STOCKS_RETURN_LIST, PRODUCTS_DROPDOWN, PURCHASED_PRODUCTS_DROPDOWN, REMOVE_STOCK, REMOVE_STOCK_RETURN, ROUTES_DROPDOWN, STOCKS_REPORT, UPDATE_INVENTORY, UPDATE_STOCK_RETURN } from "./types";


export const inventoryListAction = (data, onSuccess, onError) => {
    return {
        type: INVENTORY_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const newStockListAction = (data, onSuccess, onError) => {
    return {
        type: NEW_STOCKS_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const addStockAction = (data, onSuccess, onError) => {
    return {
        type: ADD_STOCK,
        data,
        onSuccess,
        onError,
    };
};

export const removeStockAction = (data, onSuccess, onError) => {
    return {
        type: REMOVE_STOCK,
        data,
        onSuccess,
        onError,
    };
};

export const prodcutsDropdownAction = (data, onSuccess, onError) => {
    return {
        type: PRODUCTS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const updateInventoryAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_INVENTORY,
        data,
        onSuccess,
        onError,
    };
};

export const editInventoryAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_INVENTORY,
        data,
        onSuccess,
        onError,
    };
};

export const deleteInventoryAction = (data, onSuccess, onError) => {
    return {
        type: DELETE_INVENTORY,
        data,
        onSuccess,
        onError,
    };
};

/**Stock report */
export const stockReportAction = (data, onSuccess, onError) => {
    return {
        type: STOCKS_REPORT,
        data,
        onSuccess,
        onError,
    };
};

/**Stock return */

export const routesDropdownAction = (data, onSuccess, onError) => {
    return {
        type: ROUTES_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const customersDropdownAction = (data, onSuccess, onError) => {
    return {
        type: CUSTOMERS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const purchasedProductsDropdownAction = (data, onSuccess, onError) => {
    return {
        type: PURCHASED_PRODUCTS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const newStockReturnListAction = (data, onSuccess, onError) => {
    return {
        type: NEW_STOCKS_RETURN_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const addStockReturnAction = (data, onSuccess, onError) => {
    return {
        type: ADD_STOCK_RETURN,
        data,
        onSuccess,
        onError,
    };
};

export const removeStockReturnAction = (data, onSuccess, onError) => {
    return {
        type: REMOVE_STOCK_RETURN,
        data,
        onSuccess,
        onError,
    };
};

export const updateInventoryStockReturnAction = (data, onSuccess, onError) => {
    return {
        type: UPDATE_STOCK_RETURN,
        data,
        onSuccess,
        onError,
    };
};